import {
  AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { t as tr } from "@/lib/i18n";

export const ConfirmDelete = ({ label, name, onConfirm, testid, children, note = "Cette action est définitive." }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
    <AlertDialogContent data-testid={`${testid}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle>{tr("Êtes-vous sûr de vouloir supprimer")} {tr(label)} ?</AlertDialogTitle>
        <AlertDialogDescription>
          {name ? <><strong>{name}</strong><br /></> : null}{tr(note)}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testid}-cancel`}>{tr("Annuler")}</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid={`${testid}-confirm`}>
          {tr("Supprimer")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
